import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { GetSecondHandSupplyByPkService } from '../services/get-second-hand-supply-by-pk.service';

@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSupplyByPkResolver implements Resolve<boolean> {
  constructor(private getSecondHandSupplyByPkService: GetSecondHandSupplyByPkService){

  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.getSecondHandSupplyByPkService.getSecondHandSupplyByPk(route.params.id);
  }
}
